export default "__VITE_ASSET__DlVLxU_x__"